import AboutHero from './components/AboutHero';
import StorySection from './components/StorySection';
import ValuesSection from './components/ValuesSection';
import PrinciplesSection from './components/PrinciplesSection';
// import ServicesOverviewSection from './components/ServicesOverviewSection';
import TeamSection from './components/TeamSection';
import CertificationsSection from './components/CertificationsSection';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <AboutHero />
      <StorySection />
      <ValuesSection />
      <PrinciplesSection />
      {/* <ServicesOverviewSection /> */}
      <TeamSection />
      <CertificationsSection />
      <Footer />
    </div>
  );
};

export default About;
